module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allotment-cancellation/project-list/project-list.component.html
// module id = ./src/app/allocation/allotment-cancellation/project-list/project-list.component.html
// module chunks = main